<template>
  <div class="content-wrapper" v-bind:class="{ modal_open: modalActive }">
    <Loading :loading="this.loading"></Loading>
    <article v-show="!loading">
      <div class="container">
        <article>
          <div class="section white-panel mb2p pt24">
            <p class="fs14">お客様が登録されている情報・機能は以下となります。これらの登録情報の削除がされます。</p>
            <div class="bg-gray1 pd12 mb32 color-red2">
              <h3 class="fs18" v-if="isLogin()">・メールアドレス情報</h3>
              <h3 class="fs18" v-if="isTheCard()">・コスモザカード情報</h3>
              <h3 class="fs18" v-if="isBcleCard()">・ビークルカード情報</h3>
              <h3 class="fs18" v-if="isSsPay()">・コスモSS Pay</h3>
              <h3 class="fs18" v-if="isCarwash()">・洗車プリペイド</h3>
              <h3 class="fs18" v-if="isMaintePack()">・メンテナンスパック</h3>
            </div>
            <div v-if="isCarwash()">
              <h3 class="color-font2 text-center color-blue2 mb16">※以下のカード残高が削除されます。</h3>
              <section class="section border-solid-gray bg-white radius16 pt12 mb12 pb4" v-for="card in prepaidCards" :key="card.card_no">
                <dl class="dl estimate-list">
                  <dt class="pt0 fs1 font-weight-bold" style="width: 20%;">SS名</dt>
                  <dd class="pt0 fs13" style="width: 80%;">
                    <span>{{ card.ss_name }}</span>
                  </dd>
                  <dt class="pt0 fs1 font-weight-bold">カード残高</dt>
                  <dd class="pt0 fs13">
                    <span>{{ card.value_amount_sum }}円分</span>
                  </dd>
                </dl>
              </section>
            </div>
            <div v-if="isMaintePack()">
              <h3 class="color-font2 text-center color-blue2 mb16">※以下のメンテナンスパック情報が削除されます。</h3>
              <section class="section border-solid-gray bg-white radius16 pt12 mb12 pb4">
                <h3 class="section-title fs13 mb12">メンテナンスパック</h3>
                <dl class="dl estimate-list">
                  <dt class="pt0 fs1 font-weight-bold" style="width: 20%;">SS名</dt>
                  <dd class="pt0 fs13" style="width: 80%;">
                    <span>{{ maintePackSsName }}</span>
                  </dd>
                  <dt class="pt0 fs1 font-weight-bold">コース名</dt>
                  <dd class="pt0 fs13">
                    <span>{{ maintePackCourseName }}</span>
                  </dd>
                </dl>
              </section>
            </div>
          </div>
          <section class="section white-panel mb2p pt24">
            <h2 class="fs16 font-weight-bold mb12 color-red2">（注意）※必ず最後までお読みください。</h2>
            <div class="bg-gray1 pd12 mb16">
              <ul>
                <li class="mb8">・メールアドレスのみ、カードのみ、等個別に情報の削除をご希望の方は、下記メールフォームから、お問い合わせください。（個別に情報の削除をご依頼いただいた場合、情報削除手続きのためにお時間を頂きますこと予めご了承ください。）
              <br>また、例えば、メールアドレスを削除された場合、コスモSS Pay、洗車プリペイド機能を使うには再度ご登録いただく必要がございます。</li>
                <li>・マイSS登録情報、お知らせ履歴も削除されます。ご注意ください。</li>
              </ul>
            </div>
            <p>※ご不明点がある場合は、下記メールアドレスまでお問い合わせください。</p>
            <p><a href="mailto:carlifesquare@cosmo-thecard.com">carlifesquare@cosmo-thecard.com</a></p>
          </section>
          <section class="section white-panel mb2p pt20">
            <p>登録情報の削除手続きを進める場合、下記チェックボックスを入力ください。</p>
            <p class="fs13 font-weight-bold mb12 color-red2" v-if="isMaintePackAndEndOfMonth()">お客様はメンテナンスパックご契約中のため、月末日はお客様情報の削除が出来ません。<br><br>お手数ですが、後日(月末日をさけて)改めてお試しください。</p>
              <div class="mb20 mt24 checkbox-left deletion-confirm">
                <label class="pl28 mb12 fs13" v-bind:style="{ opacity: isMaintePackAndEndOfMonth() ? checkboxOpacity : 1 }">
                  <input type="checkbox" class="checkbox-input1" v-model="termsChecked" v-bind:disabled="isMaintePackAndEndOfMonth()">
                  <span class="checkbox-area1"></span>
                  上記内容を確認しました。
                </label>
              </div>
              <button class="button fs16 mt20 mb16 w85p" v-bind:disabled="!termsChecked" v-on:click="modalOpen()">手続きを進める</button>
              <a href="carlifesquare://mypagemark2" class="button button-gray fs16 mb12 w85p" target="_blank">マイページへ戻る</a>
          </section>
        </article>
      </div>
    </article>
    <div class="modal_overlay">
      <div class="modal_container">
        <div class="modal_body radius8 pd28 mt8p mb8p">
          <h2 class="fs18 mb4">登録情報を削除します。</h2>
          <p class="fs14 line-height1_6 mb24">削除をすると登録された情報は<br>復元できません。<br><br>上記をご確認いただいた上で、<br><br>登録情報を削除しますか？</p>
          <button class="button fs16 w100p mb12 mb0 pd16 radius200" v-bind:disabled=isDeleteBtnDisabled v-on:click="accountDelete()">OK</button>
          <button class="button button-gray fs16 w100p mb12 mb0 pd16 radius200" v-on:click="modalClose()">キャンセル</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from '@/views/v2/Loading.vue'
import MaintePackSubscriptionsApi from '@/store/Api/maintenancePackSubscriptions'
import modal from '@/assets/v2/modal'
import PrepaidCardsForAccountDeleteApi from '@/store/Api/Common/carwashPrepaidCardsForAccountDelete'
import SsApi from '@/store/Api/Common/ss'
import AccountDeleteApi from '@/store/Api/Common/accountDelete'
import moment from 'moment'

// ネイティブの関数(deleteAccount)のパラメータに
// "0" を渡すと、ネイティブで保持しているSS情報を削除する
const delSsInfoNativeParam = '0'

const displayTheCard = ['300', '301', '310', '320', '100', '101', '110', '120']
const displayBcleCard = ['600']
const notDisplaySsPay = ['0']

export default {
  data () {
    return {
      loading: true,
      nativeData: {},
      prepaidCards: {},
      maintePackSubscriptions: {},
      maintePackSsCode: '',
      maintePackSsName: '',
      maintePackCourseName: '',
      termsChecked: false,
      modalActive: false,
      checkboxOpacity: 0.4,
      isDeleteBtnDisabled: false
    }
  },
  methods: {
    setPrepaidCards (cards) {
      this.prepaidCards = cards
    },
    setMaintePackSubscriptions (subscriptions) {
      this.maintePackSubscriptions = subscriptions
    },
    setMaintePackSsCode (ssCode) {
      this.maintePackSsCode = ssCode
    },
    setMaintePackSsName (ssName) {
      this.maintePackSsName = ssName
    },
    setMaintePackCourseName (course) {
      this.maintePackCourseName = course
    },
    isLogin () {
      return this.nativeData.authid
    },
    isTheCard () {
      return displayTheCard.includes(this.nativeData.cardType)
    },
    isBcleCard () {
      return displayBcleCard.includes(this.nativeData.cardType)
    },
    isSsPay () {
      return !notDisplaySsPay.includes(this.nativeData.qrPayState)
    },
    isCarwash () {
      return Boolean(Object.keys(this.prepaidCards).length)
    },
    isMaintePack () {
      return Boolean(Object.keys(this.maintePackSubscriptions).length)
    },
    modalOpen () {
      if (this.isMaintePackAndEndOfMonth()) {
        const title = 'お客様情報の削除が出来ません。'
        const message = 'お客様はメンテナンスパックご契約中のため、月末日はお客様情報の削除が出来ません。お手数ですが、後日(月末日をさけて)改めてお試しください。'
        this.openErrorModal(message, title)
      } else {
        this.nativeEVENTSet('MypageAccountDeleteButton', 'DELETE', 'TAP')
        window.modalHeight = window.pageYOffset
        window.scrollTo(0, 0)
        this.modalActive = true
      }
    },
    modalClose () {
      this.nativeEVENTSet('MypageAccountDeleteCancelButton', 'DELETECANCEL', 'TAP')
      window.scrollTo(0, window.modalHeight)
      this.modalActive = false
    },
    openErrorModal (message, title) {
      title ? modal.alert(message, title) : modal.alert(message)
    },
    isEndOfMonth () {
      const now = moment()
      const today = now.date()
      const endOfMonth = now.daysInMonth()

      return today === endOfMonth
    },
    isMaintePackAndEndOfMonth () {
      return this.isMaintePack() && this.isEndOfMonth()
    },
    accountDelete () {
      this.isDeleteBtnDisabled = true
      this.nativeEVENTSet('MypageAccountDeleteOKButton', 'DELETEOK', 'TAP')
      const authId = this.nativeData.authid
      const tsid = this.nativeData.tsid
      const otoken = this.nativeData.otoken
      const usedDtwash = this.isCarwash()
      const usedMaintePack = this.isMaintePack()
      const maintePackSscode = usedMaintePack ? this.maintePackSsCode : null
      const appVersion = `${this.nativeData.xClsAppVersion}/${this.nativeData.xClsOs}/${this.nativeData.xClsOsVersion}`

      AccountDeleteApi.delete(authId, tsid, otoken, usedDtwash, usedMaintePack, maintePackSscode, appVersion).then(res => {
        if ('Android' in window) {
          Android.deleteAccount(delSsInfoNativeParam)
        } else if ('webkit' in window) {
          webkit.messageHandlers.deleteAccount.postMessage(delSsInfoNativeParam)
        }
        this.$router.push('/v2/accountDelete/complete')
        this.isDeleteBtnDisabled = false
      }).catch(e => {
        this.isDeleteBtnDisabled = false
        console.log('AccountDeleteApi-error')
        console.log(e.message)
        this.openErrorModal('エラーが発生しました。')
      })
    }
  },
  async mounted () {
    let isApiError = false
    this.nativeData = {
      tsid: this.$route.query.tsid,
      popinfoid: this.$route.query.popinfoid,
      otoken: this.$route.query.otoken,
      authid: this.$route.query.authid || null,
      xClsAppVersion: this.$route.query.x_cls_app_version,
      xClsOs: this.$route.query.x_cls_os,
      xClsOsVersion: this.$route.query.x_cls_os_version,
      cardType: this.$route.query.card_type,
      qrPayState: this.$route.query.qr_pay_state
    }

    if (this.nativeData.authid) {
      // プリペイドカード情報取得
      await PrepaidCardsForAccountDeleteApi.get(this.nativeData.authid).then(res => {
        this.setPrepaidCards(res.data.body.cards)
      }).catch(e => {
        console.log('PrepaidCardsForAccountDeleteApi-error')
        console.log(e.message)
        if (!isApiError) {
          this.openErrorModal('エラーが発生しました。')
          isApiError = true
        }
      })

      // メンテパック情報取得
      await MaintePackSubscriptionsApi.get(this.nativeData.authid).then(res => {
        if (res.data[0]) {
          this.setMaintePackSubscriptions(res.data)
          this.setMaintePackCourseName(res.data[0].maintenance_pack_subscription.maintenance_pack_course.display_name)
        }
      }).catch(e => {
        console.log('MaintePackSubscriptionsApi-error')
        console.log(e.message)
        if (!isApiError) {
          this.openErrorModal('エラーが発生しました。')
          isApiError = true
        }
      })

      // メンテパックのSS情報取得
      if (this.isMaintePack()) {
        await SsApi.get(this.maintePackSubscriptions[0].maintenance_pack_subscription.ss_code).then(res => {
          this.setMaintePackSsName(res.data.body.ss_info.ss_name)
          this.setMaintePackSsCode(res.data.body.ss_info.ss_code)
        }).catch(e => {
          console.log('SsApi-error')
          console.log(e.message)
          if (!isApiError) {
            this.openErrorModal('エラーが発生しました。')
            isApiError = true
          }
        })
      }
    }

    if (!isApiError) {
      this.loading = false
    }

    // [eventTrack] 削除情報確認画面
    this.nativePVset('MYPAGE_ACCONUTDELETE')
  },
  components: {
    Loading
  }
}
</script>
